module.exports = __webpack_public_path__ + "img/N220-1.b8483991.png";